module.exports = __webpack_public_path__ + "static/assets/7cde88cd98adaaf1e911f68bacdbe719.svg";